// Page thumbnails for a PDF, as image data URLs — the Tax Savings Packet's page organizer. pdfjs-dist 3.11.174
// (Philip 2026-10-30) is imported here only, on demand, so it never sits in the main bundle.
let pdfjsPromise = null;
function loadPdfjs() {
  if (!pdfjsPromise) {
    pdfjsPromise = import('pdfjs-dist/build/pdf').then((pdfjs) => {
      pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();
      return pdfjs;
    });
  }
  return pdfjsPromise;
}

// → one data URL per page, in order. `width` is the thumbnail's width in CSS pixels (rendered at 2× for sharpness).
export async function pdfThumbnails(bytes, { width = 150 } = {}) {
  const pdfjs = await loadPdfjs();
  const doc = await pdfjs.getDocument({ data: bytes.slice(0) }).promise;
  const out = [];
  for (let n = 1; n <= doc.numPages; n += 1) {
    const page = await doc.getPage(n);
    const base = page.getViewport({ scale: 1 });
    const viewport = page.getViewport({ scale: (width * 2) / base.width });
    const canvas = document.createElement('canvas');
    canvas.width = Math.ceil(viewport.width); canvas.height = Math.ceil(viewport.height);
    await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
    out.push(canvas.toDataURL('image/png'));
    page.cleanup();
  }
  await doc.destroy();
  return out;
}
